<!--
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2026-06-11 11:40:06
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-06-11 14:04:34
 * @FilePath: /designcenter/src/layout/components/HeaderAccountGuest.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <FsTooltip
    ref="accountRef"
    :teleport="false"
    placement="bottom-end"
    trigger="hover"
    :offset-y="11"
    :popper-content-style="{
      width: '288px',
      maxWidth: '288px',
      padding: '16px',
      borderRadius: '8px',
    }"
  >
    <a class="account_icon" href="javascript:;">
      <img :src="accountImg" alt="Account" class="iconfont_nav" />
    </a>
    <template #content>
      <div class="guest_account">
        <FsButton type="red" size="mediumSmall" class="guest_account__btn" @click="signIn">Sign In</FsButton>
        <FsButton type="gray" size="mediumSmall" class="guest_account__btn" @click="signUp">Sign Up</FsButton>
      </div>
    </template>
  </FsTooltip>
</template>

<script setup lang="ts">
import { FsTooltip, FsButton } from 'fs-design'
import { ref } from 'vue'
import { handleFsLink } from '@/utils'
import accountImg from '@/assets/images/user.svg?url'

const accountRef = ref<InstanceType<typeof FsTooltip> | null>(null)

// Sign In：新开页面，跳转到 {环境域名}/login.html，redirect 为当前页面地址
const signIn = () => {
  const redirect = encodeURIComponent(window.location.href)
  window.open(handleFsLink(`/login.html?redirect=${redirect}`), '_blank')
}

// Sign Up：新开页面，跳转到固定的注册页地址
const signUp = () => {
  window.open('https://www.fs.com/register.html', '_blank')
}
</script>

<style lang="scss" scoped>
.guest_account {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__btn {
    width: 100%;
  }
}

:deep(.fs-button) {
  font-size: 13px !important;
  span {
    font-weight: 600 !important;
  }
}

:deep(.fs-button + .fs-button) {
  margin-left: 0 !important;
  color: #19191a;
  font-weight: 600;
}

.account_icon {
  color: #19191a;
  position: relative;
  display: block;
  border-radius: 4px;

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    transition: background 0.3s ease-in-out;
    z-index: 1;
    border-radius: 4px;
  }

  &:hover {
    text-decoration: none;
    background: unset;

    &::before {
      background: color-mix(in hsl, #fff 40%, transparent);
    }
  }

  .iconfont_nav {
    width: 24px;
    height: 24px;
    border-radius: 4px;
  }
}
</style>
